import React from 'react';
import Abnormal from '@home/components/Abnormal';


const LifetimeCardContainer = (props: any) => {
  const {
    id = 'gross',
    children,
    parentLoading,
    parentError,
    loadingTargetNames,
    switchDataLoadingHeight = 454,
    ...restProps
  } = props;
  const { by_tab } = props?.data || {};
  if (id === by_tab) {
    return (
      <div>
        {React.Children.map(children, (child: any) => {
          const childName = child?.props?.config?.name;
          const clonedChild = React.cloneElement(child, {
            ...restProps,
          });

          // 精确 loading 控制：只给 loadingTargetNames 匹配的 children 包裹 Abnormal
          if (
            loadingTargetNames?.length
            && childName
            && loadingTargetNames.includes(childName)
          ) {
            return (
              <Abnormal
                isLoading={parentLoading === undefined ? false : parentLoading}
                isError={parentError}
                style={{ background: '#fff', height: switchDataLoadingHeight, borderRadius: 8, marginBottom: 20 }}
                component={clonedChild}
              />
            );
          }

          return clonedChild;
        })}
      </div>
    );
  }
  return null;
};

export default LifetimeCardContainer;
